import { ref, computed } from 'vue';
import router from '@/router/router';

export default function useRouter() {
    const routerInstance = ref(router);

    const route = computed(() => routerInstance.value?.currentRoute);

    return {
        router: routerInstance,
        route,
    };
}
